// src/pages/authorized/Private.jsx
import React from 'react';
import { Switch, Route } from 'react-router-dom';
import PrivateRoute from 'components/common/PrivateRoute';
import { useSelector } from 'react-redux';
import { REGISTRY, ERROR_ROUTE } from 'utils/resourceConfig';
import PageError from 'components/layout/PageError';
import { getPermissions, hasPermission } from 'utils/permission';

const PermissionRoute = ({resource, requiredAction = 'read', component: Component, allowIfMissing = false, ...rest}) => {
    const auth = useSelector((s) => s.auth.user);
    const permissions = getPermissions(auth);
    const ok = hasPermission(permissions, resource, requiredAction) || allowIfMissing;

    return ok ? (
        <PrivateRoute {...rest} component={Component} />
    ) : (
        <PrivateRoute {...rest} component={PageError} />
    );
};

const Private = () => {
    const routeNodes = REGISTRY.flatMap((item) => {
        const { resource, routes = [], children = [], always } = item;
        const all = [...routes.map((r) => ({ ...r, _resource: resource })), ...children.map((c) => ({ ...c, _resource: resource }))];

        return all.map((r) => (
            <PermissionRoute
                key={r.path}
                exact={r.exact}
                path={r.path}
                component={r.component}
                resource={r._resource}
                requiredAction="read"
                allowIfMissing={!!always}
            />
        ));
    });

    return (
        <Switch>
            {routeNodes}
            <PrivateRoute exact path={ERROR_ROUTE.path} component={ERROR_ROUTE.component} />
            <Route component={PageError} />
        </Switch>
    );
};

export default Private;
